<template>
  <svg
    width="311"
    height="156"
    viewBox="0 0 311 156"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_25_1223)">
      <path
        d="M310.87 155.565C310.87 135.153 306.85 114.941 299.038 96.0825C291.227 77.2243 279.778 60.0892 265.344 45.6557C250.911 31.2223 233.776 19.773 214.917 11.9617C196.059 4.15033 175.847 0.129882 155.435 0.129883C135.023 0.129884 114.811 4.15033 95.9526 11.9617C77.0944 19.773 59.9593 31.2223 45.5259 45.6558C31.0924 60.0892 19.6431 77.2243 11.8318 96.0825C4.02044 114.941 -1.78447e-06 135.153 0 155.565L70.2855 155.565C70.2855 144.383 72.488 133.31 76.7672 122.98C81.0463 112.649 87.3184 103.262 95.2252 95.3551C103.132 87.4483 112.519 81.1762 122.85 76.897C133.181 72.6179 144.253 70.4154 155.435 70.4154C166.617 70.4154 177.69 72.6179 188.02 76.897C198.351 81.1762 207.738 87.4483 215.645 95.3551C223.552 103.262 229.824 112.649 234.103 122.98C238.382 133.31 240.585 144.383 240.585 155.565H310.87Z"
        fill="url(#paint0_linear_25_1223)"
      />
      <mask
        id="mask0_25_1223"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="311"
        height="156"
      >
        <path
          d="M310.87 155.565C310.87 135.153 306.85 114.941 299.038 96.0825C291.227 77.2243 279.778 60.0892 265.344 45.6557C250.911 31.2223 233.776 19.773 214.917 11.9617C196.059 4.15033 175.847 0.129882 155.435 0.129883C135.023 0.129884 114.811 4.15033 95.9526 11.9617C77.0944 19.773 59.9593 31.2223 45.5259 45.6558C31.0924 60.0892 19.6431 77.2243 11.8318 96.0825C4.02044 114.941 -1.78447e-06 135.153 0 155.565L70.2855 155.565C70.2855 144.383 72.488 133.31 76.7672 122.98C81.0463 112.649 87.3184 103.262 95.2252 95.3551C103.132 87.4483 112.519 81.1762 122.85 76.897C133.181 72.6179 144.253 70.4154 155.435 70.4154C166.617 70.4154 177.69 72.6179 188.02 76.897C198.351 81.1762 207.738 87.4483 215.645 95.3551C223.552 103.262 229.824 112.649 234.103 122.98C238.382 133.31 240.585 144.383 240.585 155.565H310.87Z"
          fill="#FDD104"
        />
      </mask>
      <g mask="url(#mask0_25_1223)">
        <path
          d="M-0.570131 155.509C-0.570129 127.403 7.05045 99.8231 21.4805 75.7046C35.9106 51.5862 56.6102 31.8316 81.3762 18.5434C106.142 5.25519 134.048 -1.06929 162.123 0.243048C173.193 0.760534 184.127 2.45784 194.746 5.27688L217.777 43.5779C220.272 47.7264 218.639 53.1219 214.262 55.1902L176.339 73.1114C170.639 71.6258 164.776 70.7294 158.841 70.4519C143.461 69.733 128.174 73.1977 114.607 80.4771C101.04 87.7566 89.7001 98.5784 81.7951 111.791C73.8901 125.003 69.7154 140.112 69.7154 155.509L-0.570131 155.509Z"
          fill="url(#paint1_linear_25_1223)"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_25_1223"
        x1="145.209"
        y1="85.0056"
        x2="302.689"
        y2="140.226"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C18000" />
        <stop offset="1" stop-color="#EDA101" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_25_1223"
        x1="30.7748"
        y1="-8.20806"
        x2="156.981"
        y2="-5.09278"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EC9C00" />
        <stop offset="1" stop-color="#FBE205" />
      </linearGradient>
      <clipPath id="clip0_25_1223">
        <rect width="311" height="156" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
